import countryList from 'react-select-country-list';
import SUPPORTED_CREATOR_COUNTRIES from '@helpers/supported-creator-countries';

const SUPPORTED_CREATOR_COUNTRY_CODES = SUPPORTED_CREATOR_COUNTRIES.map(c => c.code);
const SELECTOR_SUPPORTED_COUNTRIES = countryList().getData();
const SUPPORTED_COUNTRIES = SELECTOR_SUPPORTED_COUNTRIES.filter(c => SUPPORTED_CREATOR_COUNTRY_CODES.includes(c.value));

export default SUPPORTED_COUNTRIES;
